/**
 * DeliveryRequest
 * @author gil
 */
import {
  Resource,
  Collection,
  $,
} from 'simpli-web-sdk'
import Responsavel from '@/model/resource/Responsavel'
import ResponsavelConfigSms from '@/model/resource/ResponsavelConfigSms'

export default class ResponsavelConfigSmsRequest extends Resource {
  readonly $name: string = 'ResponsavelConfigSmsRequest'
  readonly $endpoint = '/user/sms/configuracao{/id}'
  $id = 0

  responsavel: Responsavel | null = null
  list: ResponsavelConfigSms[] = []

  async populate(spinner = 'populateResponsavelConfigSmsRequest') {
    const collection = new Collection(ResponsavelConfigSms)
    await $.await.run(() => collection.query(), spinner)
    this.list = collection.items
  }
}
